import axios from "axios"
import store from "./store"
import router from "./router"

const baseURL = process.env.VUE_APP_API_URL
const timeout = 10000

const instance = getNewAxiosInstance()

function getNewAxiosInstance() {
  return axios.create({
    baseURL,
    timeout,
  })
}

instance.interceptors.request.use(
  function (config) {
    config.headers.Authorization = `Bearer ${store.getters["auth/token"]}`
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

export function responseErrorHandler(error) {
  if (error.code === "ECONNABORTED" || error.message === "Network Error") {
    router.push({ name: "sistemaIndisponivel" })
  } else if (error.response.status === 401) {
    store.dispatch("auth/removeToken")
    router.push({ name: "login" })
  } else if (error.response.status === 403) {
    router.replace({ name: "acessoNegado" })
  } else if (error.response.status === 404) {
    router.push({ name: "paginaNaoEncontrada" })
  }
  return Promise.reject(error)
}

instance.interceptors.response.use((response) => {
  // eslint-disable-next-line no-prototype-builtins
  if (response.headers.hasOwnProperty("authorization")) {
    store.dispatch("auth/updateToken", {
      token: response.headers.authorization,
    })
  }
  return response
}, responseErrorHandler)

export { getNewAxiosInstance, instance }
export default instance
